

const HoverSprite = require('../elements/highlightsprite.js')
const { getNormalizedTargetBounds } = require('../../shared_utils/coordinates.js')
const AppliedGlitches = require('../elements/applied-glitches.js')
const { BUILTIN_PHYSICS } = require('../../shared_utils/gamebender-constants.js')
module.exports = function SpriteHighlight(state) {
  let targetsToHighlight = []
  if (state.hoveringTargetId && state.hoveringTargetId !== state.selectedTargetId) {
    const hoverTarget = state.vm.runtime.targets.find(
      t => t.id === state.hoveringTargetId
    )
    if (!hoverTarget) {
      return null
    }
    targetsToHighlight = hoverTarget.sprite.clones
    
  } else if (state.selectedTargetId) {
    const selectedTarget = state.vm.runtime.targets.find(
      t => t.id === state.selectedTargetId
    )
    targetsToHighlight = selectedTarget.sprite.clones
      .filter(clone => clone.id !== state.selectedTargetId && clone.visible)
  }

  let highlights = []
  let appliedGlitches = []

  targetsToHighlight.forEach(clone => {
    const originalId = clone.id
    const bounds = getNormalizedTargetBounds(clone, state.canvas)
    if (!bounds) {
      return
    }
    const { width, height, top, left } = bounds
    highlights.push(
      HoverSprite({
        width,
        height,
        top,
        left,
        highlight: true
      })
    )
    const glitches = state.glitchApplications
    .filter(g => g.targetId === originalId && g.glitchId !== BUILTIN_PHYSICS)
    .map(h => {
      const glitch = state.availableGlitches.find(g => g.id === h.glitchId)
      return {
        ...glitch,
        applicationId: h.id
      }
    })
    appliedGlitches.push(
      AppliedGlitches({
        top: top + height,
        left,
        glitches,
        width,
        height,
        beginDrag: () =>{},
        selectedGlitchApplicationId: null
      })
    )
  });

  return { highlights }
}